import * as auth from "modules/auth/slices";
import * as billing from "modules/billing/slices";
import * as clusters from "modules/clusters/slices";
import * as databases from "modules/databases/slices";
import * as enterprises from "modules/enterprises/slices";
import * as instances from "modules/instances/slices";
import * as networks from "modules/networks/slices";
import * as news from "modules/news/slices";
import * as nlp from "modules/nlp/slices";
import * as notifications from "modules/notifications/slices";
import * as objectStorage from "modules/objectStorage/slices";
import * as polling from "modules/polling/slices";
import * as projects from "modules/projects/slices";
import * as security from "modules/security/slices";
import * as storage from "modules/storage/slices";
import * as support from "modules/support/slices";
import * as backups from "modules/backups/slices";
import * as loadBalancers from "modules/loadBalancers/slices";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  instances: instances.reducer,
  clusters: clusters.reducer,
  storage: storage.reducer,
  backups: backups.reducer,
  networks: networks.reducer,
  notifications: notifications.reducer,
  projects: projects.reducer,
  security: security.reducer,
  enterprises: enterprises.reducer,
  polling: polling.reducer,
  billing: billing.reducer,
  databases: databases.reducer,
  objectStorage: objectStorage.reducer,
  loadBalancers: loadBalancers.reducer,
  nlp: nlp.reducer,
  news: news.reducer,
  support: support.reducer
});

export type RootState = ReturnType<typeof rootReducer>;
